<!--Vista que muestra la lista de afiliados a un plan en específico 
    A esta vista solo pueden acceder los usuarios de tipo ORGANIZADOR y se puede llegar a ella
    dando click en "Ver afiliados" o dando click en el número de afiliados en la tabla de
    afiliados que sale en el dashboard.
-->
<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="10" md="8" xl="6" class="elevation-1 mb-5 primary white--text text-center">
            <h1 class="display-2">{{ affiliation.name }}</h1>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="11" lg="10" class="elevation-2 pa-5">
            <v-row justify="space-around">
              <v-col cols="12" md="7" class="text-center text-md-left pb-0">
                <span class="headline font-weight-bold mr-5">Afiliados</span>
                <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv(affiliation.name)">
                  Reporte<v-icon right>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="11" md="5" class="pt-0">
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                      class="mr-0 mr-md-5"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="accent" class="black--text font-weight-bold" @click="reloadTable()" v-on="on" fab small>
                          <v-icon class="black--text font-weight-bold">mdi-cached</v-icon>
                        </v-btn>
                      </template>
                      <span>Actualizar lista de Afiliados</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :search="search"
              :items="affiliation.affiliates"
              sort-by="affiliateId"
              :sort-desc="true"
              :header-props="{
                sortByText:'Ordenar por'
              }"
              :footer-props="{
                itemsPerPageText: 'Filas por página',
                itemsPerPageAllText:'Todas',
              }"
            >
              <template v-slot:body="{items}">
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                    class="text-center"
                    :class="[($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
                  >
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[0].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.affiliateId.substring(item.affiliateId.length-5, item.affiliateId.length)}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[1].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.level}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[2].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.name}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[3].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.lastName}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[4].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.company}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[5].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.email}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[6].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.tel || 'N/D'}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[7].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.rfc || 'N/D'}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[8].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.date}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[9].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                        <v-chip v-if="item.status=='Activo'" color="success">
                          {{item.status}}
                        </v-chip>
                        <v-chip v-else-if="item.status=='En progreso'" color="secondary">
                          {{item.status}}
                        </v-chip>
                        <v-chip v-else color="error">
                          {{item.status}}
                        </v-chip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";
import exportFromJSON from "export-from-json";
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Id de afiliado", value: "affiliateId"},
        { text: "Nivel de afiliado", value: "level" },
        { text: "Nombre", value: "name" },
        { text: "Apellidos", value: "lastName" },
        { text: "Empresa", value: "company" },
        { text: "Email", value: "email" },
        { text: "Teléfono", value: "tel" },
        { text: "RFC", value: "rfc" },
        { text: "Fecha de vencimiento", value: "date" },
        { text: "Estatus", value: "status" }
      ],
      affiliation: {
        name: "",
        affiliates: []
      },
      affiliatesCsv: [] 
    };
  },
  computed: {
    ...mapState("plan", ["plans"])
  },
  methods: {
    ...mapActions("plan", ["fetchUserPlans"]),
    ...mapMutations("notifications", ["show"]),
    /**
     * Función para descargar el reporte de los afiliados.
     * @param { String } planName Nombre del plan.
     */
    async downloadCsv(planName) {
      //let data = await this.getAssistants();
      const fileName = `Afiliados ${planName}`;
      const exportType = "csv";
      let data = this.affiliatesCsv;
      // Ordenar por apellido de manera ascendente.
      data.sort(function(a, b) {
        if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
          return 1;
        }
        if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      exportFromJSON({ data, fileName, exportType });
    },
    /**
     * Función que sirve para poner estatus del afiliado en la tabla de afiliados.
     * @param {String} estatus Estatus del afiliado obtenido directamente de la base de datos.
     */
    formatEstatus(estatus) {
      let newEstatus = "";
      switch (estatus) {
        case "ACTIVE":
          newEstatus = "Activo";
          break;
        case "IN_PROGRESS":
          newEstatus = "En progreso";
          break;
        case "UNPAID":
          newEstatus = "Expirado";
          break;
        default:
          break;
      }
      return newEstatus;
    },
    /**
     * Función que ayuda a acomodar la lista de afiliados para que sean mostrados en la tabla de la forma correcta.
     */
    formatData() {
      let selectedPlan = this.plans.filter(
        plan => plan.id == this.$route.params.id
      );
      this.affiliation.affiliates = selectedPlan[0].affiliations.map(data => {
        return {
          affiliateId: data.affiliateId?'00000'+data.affiliateId.toString():'N/D',
          level: data.tier.name,
          name: data.affiliateData.name,
          lastName: data.affiliateData.lastName,
          company: data.affiliateData.companyName,
          email: data.affiliateData.email,
          tel: data.affiliateData.tel ? data.affiliateData.tel : "N/D",
          rfc: data.affiliateData.rfc ? data.affiliateData.rfc : "N/D",
          status: this.formatEstatus(data.estatus),
          date: data.expirationDate
            ? new Date(data.expirationDate).toLocaleDateString("es-MX")
            : "N/D"
        };
      });
      this.affiliation.affiliates = this.affiliation.affiliates.filter(affiliate => affiliate.status != "En progreso");
      this.affiliatesCsv = selectedPlan[0].affiliations.map(affiliation => {
        affiliation.affiliateData.affiliateId = affiliation.affiliateId?affiliation.affiliateId:'N/D';
        affiliation.affiliateData.planLevel = affiliation.tier.name;
        affiliation.affiliateData.status = this.formatEstatus(affiliation.estatus);
        affiliation.affiliateData.expirationDate = affiliation.expirationDate
          ? new Date(affiliation.expirationDate).toLocaleDateString("es-MX")
          : "N/D"
        return affiliation.affiliateData;
      });

      //Quitar afiliados en progreso
      this.affiliatesCsv = this.affiliatesCsv.filter(affiliate => affiliate.status!="En progreso");
      this.affiliation.name = selectedPlan[0].name;
    },
    /**
     * Función para recargar la tabla de afiliados
     */
    async reloadTable() {
      await this.fetchUserPlans();
      this.formatData();
    }
  },
  mounted() {
    this.formatData();
  }
};
</script>